__turbopack_context__.v({
  "container": "Footer-module__7vZ9Tq__container",
  "content": "Footer-module__7vZ9Tq__content",
  "copyright": "Footer-module__7vZ9Tq__copyright",
  "footer": "Footer-module__7vZ9Tq__footer",
  "links": "Footer-module__7vZ9Tq__links",
  "logo": "Footer-module__7vZ9Tq__logo",
  "social": "Footer-module__7vZ9Tq__social",
});
